const PREFIX = '[FILTERED]';

export const RESET_ENTITY_FILTERS = `${PREFIX} RESET_ENTITY_FILTERS`;

export const resetEntityFilters = (payload) => ({
  type: RESET_ENTITY_FILTERS,
  payload,
});
